<div class="p-5 mt-3">
    <div class="flex justify-between items-center">
        <div class="text-lg text-gray-700 font-bold ">Visualizar Occorrência</div>
        <button class="btn-icon" (click)="closeModal()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div [formGroup]="form" class="mt-4 container mx-auto">

        <!-- @if (checkPermission('criar')) {
    <button class="btn-add mdc-button mr-8 mdc-button--raised mat-mdc-raised-button mat-unthemed mat-mdc-button-base"
      (click)="openPassengerForm()">
      <span class="mat-mdc-button-persistent-ripple mdc-button__ripple"></span>
      <span class="mdc-button__label">Novo</span>
      <span class="mat-focus-indicator"></span>
      <span class="mat-mdc-button-touch-target"></span>
      <span class="mat-ripple mat-mdc-button-ripple"></span>
    </button>
  } -->
        <div class="flex justify-start items-center  mt-3 mx-2 gap-x-7 w-12/12">
            <mat-form-field class="input-tg w-3/12" appearance="outline" hideRequiredMarker>
                <mat-label class="text-sm text-gray-600 mb-1">Data</mat-label>
                <input matInput [matDatepicker]="start" formControlName="date" placeholder="00/00/0000" readonly />
                <mat-datepicker-toggle matIconSuffix [for]="start" [disabled]="true"></mat-datepicker-toggle>
                <mat-datepicker #start></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="input-tg w-2/12" appearance="outline" hideRequiredMarker>
                <mat-label>Hora</mat-label>
                <input matInput type="time" formControlName="hour" readonly />
            </mat-form-field>

        </div>
        <div class="flex flex-row justify-around items-center gap-x-4 w-full">
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline">
                <mat-label>Código TG</mat-label>
                <input matInput formControlName="codeTg" readonly />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Código OS</mat-label>
                <input matInput formControlName="codeOs" [mask]="documentMask" readonly />
            </mat-form-field>
        </div>

        <!-- <div class="flex flex-row justify-around items-center gap-x-4 w-full">
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Tipo Occorrência</mat-label>
                <mat-select formControlName="typeOccurrence" [disabled]="true">
                    @for (type of listTypeOccurrence; track type) {
                    <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Occorrência</mat-label>
                <mat-select formControlName="occurrence">
                    @for (type of listOccurrence; track type) {
                    <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div> -->
        <div class="flex flex-row justify-around items-center gap-x-4 w-full">
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Tipo Occorrência</mat-label>
                <input matInput formControlName="typeOccurrence" readonly />
            </mat-form-field>
            <mat-form-field class="input-tg w-3/4 px-2" appearance="outline" hideRequiredMarker>
                <mat-label>Occorrência</mat-label>
                <input matInput formControlName="occurrence" readonly />

            </mat-form-field>
        </div>

        <div class="flex justify-center items-center gap-x-7 w-full">
            <mat-form-field class="input-tg w-full px-2" appearance="outline">
                <mat-label>Observação</mat-label>
                <textarea type="text" matInput formControlName="observation" readonly></textarea>
            </mat-form-field>
        </div>


    </div>


</div>